export default __webpack_public_path__ + "static/media/trailer.870c8054.mp4";